import { useContext } from 'react';
import { useKeycloakReady } from 'hooks';
import { useSWRConfig } from 'swr';
import { osName, osVersion } from 'react-device-detect';

import ProfileTabs from './ProfileTabs';
import { LogoutButton } from '../LogoutButton';
import { BravoProfileHeader } from '../styledComponents';
import { UserAccessActionTypes } from '../../../../../contexts/home/actions';
import { sessionStorageService } from 'utils/SessionStorageService';
import { HomeContext } from 'contexts/home/context';
import { ProfileAvatar } from 'components/profileAvatar';
import { useProfileInfoContext } from 'contexts/profileInfo';
import _ from 'lodash';
import { usePatchReminder, useLogLogout } from 'all-in-one-shared-api';
import { removeCookie } from 'utils/cookies';

const ProfileHeader = () => {
  const { mutate } = useSWRConfig();
  const { keycloak } = useKeycloakReady();
  const { state: data } = useProfileInfoContext();
  const { state: homeData, dispatch } = useContext(HomeContext);
  const logLogout = useLogLogout({
    sourceOfRequest: window.location.pathname,
    media: 'WEB',
    authToken: keycloak.token,
    device: osName,
    deviceVersion: osVersion,
  });
  const news = _.get(homeData, 'userAccess.reminders[0]');
  const patchReminder = usePatchReminder(keycloak.token || '', news?.id || 0);

  const onLogoutPressed = async () => {
    try {
      news?.id && (await patchReminder());
      sessionStorageService.clear();
      removeCookie('KeycloakTokens');
      await logLogout();
      await mutate(() => true, undefined, { revalidate: false });
    } catch (error) {
      // TODO: show a https://ant.design/components/notification/ ?
      // console.log('onLogoutPressed()->Error occurred', error);
    }

    await keycloak.logout();
    dispatch({ type: UserAccessActionTypes.LOGOUT });
  };

  return (
    <BravoProfileHeader
      title={[data?.lastName, data?.firstName].filter((name) => !!name).join(' ')}
      avatar={{
        src: <ProfileAvatar memberType={data?.memberType ?? ''} />,
        icon: <ProfileAvatar memberType={data?.memberType ?? ''} />,
      }}
      ghost={false}
      extra={<LogoutButton onClick={onLogoutPressed} />}
    >
      <ProfileTabs />
    </BravoProfileHeader>
  );
};

export default ProfileHeader;
